module.exports = __webpack_public_path__ + "img/video-completed.bc71191d.svg";